import { el, mount, unmount } from 'redom';

import { stringToSVG } from 'utilities';

import arrowIconString from 'assets/images/node-action-control-box-arrow-icon.svg?raw';

import './index.scss';

const arrowIcon = stringToSVG(arrowIconString);

class PanelToggle {

  constructor(configuration) {

    this.expanded = false;
    this.label = configuration.label;
    this.icon = configuration.icon;
    this.contentPanel = configuration.contentPanel;
    this.onExpand = configuration.onExpand || function noop() {};
    this.onCollapse = configuration.onCollapse || function noop() {};

    this.el = el('.panel-toggle-main', [
      this.renderButton()
    ]);

  }

  renderButton() {

    return el('button.duplicate-node-button', {
      type: 'button',
      onclick: this.togglePanel.bind(this)
    }, [
      this.icon,
      el('label', this.label),
      el('span.expanded-indicator', arrowIcon.cloneNode(true))
    ]);

  }

  expand() {

    this.expanded = true;
    this.el.classList.add('expanded');

    mount(this.el, this.contentPanel);

    this.onExpand();

  }

  onComplete() {
    this.menu.onClose();
  }

  collapse() {

    this.expanded = false;

    this.el.classList.remove('expanded');

    unmount(this.el, this.contentPanel);

    this.onCollapse();

  }

  togglePanel() {

    if (this.expanded === true) {
      this.collapse();
    } else {
      this.expand();
    }

  }

  update() {}

}

export default PanelToggle;